import React from 'react';

export const AddressOfSpain = () => {
  return (
    <div id="about">
      <div className="container">
        <div className="row align-items-center">
          {/* Texto a la izquierda */}
          <div className="col-xs-12 col-md-6">
            <div className="about-text">
              <h2>Dirección en ESPAÑA</h2>
              <p>Utiliza nuestra dirección para hacer tus compras en ESPAÑA y recíbelas en Perú.</p>
              <h3>Detalles de la Dirección</h3>
              <div className="list-style">
                <ul>
                  <li><strong>Nombre:</strong> AIRBOX + NOMBRE + APELLIDOS Ó AIRBOX + RAZON SOCIAL</li>
                  <li><strong>Dirección:</strong> C/ DE  LOS TAPICEROS N°1 PUERTA J (TRASERA)</li>
                  <li><strong>Suite:</strong> SUITE 700</li>
                  <li><strong>Ciudad:</strong> SAN FERNANDO DE HENEARES</li>
                  <li><strong>Estado:</strong> MADRID </li>
                  <li><strong>País:</strong> ESPAÑA</li>
                  <li><strong>Código Postal:</strong> 28830 </li>
                  <li><strong>Teléfono:</strong> +34 697102256</li>
                </ul>
              </div>
            </div>
          </div>

          {/* Imagen a la derecha */}
          <div className="col-xs-12 col-md-6">
            <img
              src="/img/addressOfSpain.jpg"
              className="img-responsive address-img"
              alt="Dirección en USA"
            />
          </div>
        </div>
      </div>
    </div>
  );
};
